import React from "react";
import { Message } from "./Message";

export function PaymentMethodConflictWarning({
  supportedCategories = [],
  localPaymentMethods = {},
  initialPaymentMethods = {},
  lastActivatedMethod = null,
  categoryLabels = {},
  integrationName = "",
  gatewayName = ""
}) {
  return (
    <>
      {supportedCategories.map((cat) => {
        const isChecked = localPaymentMethods[cat] === gatewayName;
        const wasChecked = initialPaymentMethods[cat] === gatewayName;
        const alreadyActiveOther =
          initialPaymentMethods[cat] &&
          initialPaymentMethods[cat] !== gatewayName;
        return (
          lastActivatedMethod === cat &&
          isChecked &&
          !wasChecked &&
          alreadyActiveOther ? (
            <Message key={cat} type="warning" className="payment-method-warning">
              {`Ao ativar o método de pagamento ${categoryLabels[cat]} pela integração ${integrationName}, este método será desabilitado nas demais integrações de pagamento`}
            </Message>
          ) : null
        );
      })}
    </>
  );
} 